module.exports = __webpack_public_path__ + "html/section-vertical-text-video_a5686fa69f8eabc23422283a4cef14eb.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-vertical-text-video.html
// module id = Q247
// module chunks = 83